export default __webpack_public_path__ + "static/media/Group 27103.5cbf0e0e.svg";